module.exports = __webpack_public_path__ + "static/img/pic-homepage-event2.f1bf9d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic-homepage-event2.png
// module id = 1608
// module chunks = 0